import React, { ReactNode } from 'react';
import { LinkText } from '@bankiru/ui-kit/components/Link/LinkText';

import { ConsentKeys, CONSENTS } from '../../../../../types/consents';

export const CHECKBOX_DATA: Array<{
	id: ConsentKeys;
	titleContent: ReactNode;
	isRequired?: boolean;
}> = [
	{
		id: CONSENTS.IS_RULES_ACCEPTED,
		titleContent: (
			<>
				Соглашаюсь с{' '}
				<LinkText skin="blue" href="https://www.banki.ru/info/agreement/" target="_blank">
					Пользовательским соглашением
				</LinkText>
				, предоставляю свое согласие на{' '}
				<LinkText
					skin="blue"
					href="https://static4.banki.ru/cfe/consent1.pdf"
					target="_blank"
				>
					обработку персональных данных
				</LinkText>{' '}
				и на участие в{' '}
				<LinkText
					skin="blue"
					href="https://static2.banki.ru/cfe/new_loyal_22-05-23.pdf"
					target="_blank"
				>
					Программе лояльности
				</LinkText>
			</>
		),
		isRequired: true,
	},
	{
		id: CONSENTS.IS_AD_ACCEPTED,
		titleContent: (
			<>
				Предоставляю свое{' '}
				<LinkText
					skin="blue"
					href="https://static4.banki.ru/cfe/consentAdv.pdf"
					target="_blank"
				>
					согласие
				</LinkText>{' '}
				на получение рекламы и информационных сообщений
			</>
		),
	},
	{
		id: CONSENTS.IS_MARKET_ACCEPTED,
		titleContent: (
			<>
				Соглашаюсь с{' '}
				<LinkText
					skin="blue"
					href="https://static3.banki.ru/mkp/rules_ofp_v12.pdf"
					target="_blank"
				>
					Правилами
				</LinkText>{' '}
				финансовой платформы,{' '}
				<LinkText
					skin="blue"
					href="https://static2.banki.ru/mkp/legal_docflow_digital_techs.pdf"
					target="_blank"
				>
					Правилами ЭДО
				</LinkText>
				, предоставляю{' '}
				<LinkText
					skin="blue"
					href="https://static2.banki.ru/mkp/legal_agree_bki.pdf"
					target="_blank"
				>
					согласие на получение информации из БКИ
				</LinkText>
				, направляю{' '}
				<LinkText
					skin="blue"
					href="https://static2.banki.ru/cfe/client_oferta.pdf"
					target="_blank"
				>
					Оферту
				</LinkText>
			</>
		),
		isRequired: true,
	},
];

export const REQUIRED_CONSENTS: ConsentKeys[] = CHECKBOX_DATA.reduce(
	(acc, { id, isRequired }): ConsentKeys[] => {
		if (isRequired) {
			return [...acc, id];
		}

		return [...acc];
	},
	[] as ConsentKeys[],
);

export const INITIAL_CONSENTS = CHECKBOX_DATA.reduce(
	(acc, { id }) => ({
		[id]: true,
		...acc,
	}),
	{} as Record<ConsentKeys, boolean>,
);
